import classnames from 'classnames';
import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	RichText,
	__experimentalGetBorderClassesAndStyles as getBorderClassesAndStyles,
	__experimentalGetColorClassesAndStyles as getColorClassesAndStyles,
	__experimentalGetSpacingClassesAndStyles as getSpacingClassesAndStyles,
} from '@wordpress/block-editor';
import { ReactComponent as CloseButton } from './close-button.svg';

const blockAttributes = {
	lock: {
		type: 'object',
		default: {
			move: true,
			remove: false,
		},
	},
	text: {
		type: 'string',
		source: 'text',
		selector: 'button.wp-block-popper__close',
		default: 'Close',
	},
	isIcon: {
		type: 'boolean',
		selector: 'svg',
		default: true,
	},
	position: {
		type: 'string',
	},
	style: {
		type: 'object',
	},
};

const supports = {
	html: true,
	ariaLabel: true,
	lock: false,
	multiple: false,
	reusable: false,
	className: false,
	color: {
		background: true,
		text: true,
		gradients: true,
	},
	__experimentalBorder: true,
	typography: {
		fontSize: true,
		lineHeight: true,
	},
	spacing: {
		margin: true,
		padding: true,
		__experimentalDefaultControls: {
			padding: true,
		},
	},
};

const v1 = {
	attributes: blockAttributes,
	supports,
	migrate( { openBehaviour, ...restAttributes } ) {
		console.log( openBehaviour );
		return {
			...restAttributes,
			openBehaviour: [ openBehaviour ],
		};
	},
	save( { attributes, className } ) {
		const { text, position, isIcon, style } = attributes;

		const borderRadius = style?.border?.radius;
		const borderProps = getBorderClassesAndStyles( attributes );

		// Check for old deprecated numerical border radius. Done as a separate
		// check so that a borderRadius style won't overwrite the longhand
		// per-corner styles.
		if ( typeof borderRadius === 'number' ) {
			borderProps.style.borderRadius = `${ borderRadius }px`;
		}

		const colorProps = getColorClassesAndStyles( attributes );

		const buttonClasses = classnames(
			borderProps.className,
			colorProps.className,
			'wp-block-popper__close',
			{
				'wp-block-popper__close-outside': 'outside' === position,
				'wp-block-popper__close-corner': 'corner' === position,
			}
		);

		const blockProps = useBlockProps.save( {
			className: buttonClasses,
			style: colorProps.style,
		} );

		if ( isIcon ) {
			return (
				<button
					{ ...blockProps }
					aria-label={ __( 'Close modal', 'popper' ) }
				>
					<svg viewBox="0 0 16 16">
						<path d="M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z"></path>
					</svg>
				</button>
			);
		}
		return (
			<RichText.Content
				{ ...blockProps }
				tagName="button"
				value={ text }
			/>
		);
	},
};

const deprecated = [ v1 ];

export default deprecated;
